import { render, staticRenderFns } from "./iplimited.vue?vue&type=template&id=5af0762e&scoped=true&"
import script from "./iplimited.vue?vue&type=script&lang=js&"
export * from "./iplimited.vue?vue&type=script&lang=js&"
import style0 from "./iplimited.vue?vue&type=style&index=0&id=5af0762e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0762e",
  null
  
)

export default component.exports